import { UnviewedIndicatorText } from "@/components/ui/unviewed-indicator-text";
import type { Screening } from "@/types/screeners";
import type { PropsWithTableInfo } from "@/types/third-party";
import type { Nullable } from "@/types/utils";

export const UnviewedIndicatorTextCell = ({
  info,
}: PropsWithTableInfo<Screening, Nullable<string>>) => {
  return (
    <UnviewedIndicatorText
      indicatorText="NEW"
      // An em dash is what every other cell in this table shows for a missing
      // value (text-cell.tsx), so a nameless session reads as a gap rather than
      // as a cell that failed to render (SRN-803).
      primaryText={info.getValue() ?? "—"}
      showIndicatorText={!info.row.original.viewedAt}
    />
  );
};
